// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import { CartProvider } from "./components/CartContext";
import HomePage from "./Home";
import ConfirmationPage from "./components/ConfirmPage";
import Navbar from "./Homepage/Navbar";
import SafeTips from "./components/SafeTips";
import Contact from "./components/Contact";
import About from "./components/About";
import Footer from "./Homepage/Footer";
import Admin from "./components/Admin";
import Dashboard from "./components/dashboard";
import LoginRegister from "./components/LoginRegister";
import BulkShop from "./components/BulkShop";

function App() {
  return (
    <CartProvider>
      <Navbar /> {/* Moved outside of <Routes> */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/safetips" element={<SafeTips />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/user-dashboard" element={<Dashboard />} />
        <Route path="/loginRegistor" element={<LoginRegister />} />
        <Route path="/bulk-shop" element={<BulkShop />} />
      </Routes>
      <Footer />
    </CartProvider>
  );
}

export default App;
